import { DeepPartial } from '@thesisedu/feature-types'
import { mergeDeep } from '@thesisedu/feature-utils'

import { DEFAULT_THEME } from './defaults'
import { Theme } from './types'

export function mergeTheme(overrides: DeepPartial<Theme>): Theme {
  return mergeDeep(DEFAULT_THEME, overrides)
}
